import { CandidateProfileFormData } from 'features/profile/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedTextField } from 'shared/components';

export default function FieldLastName() {
    const { control } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');

    return (
        <ConnectedTextField
            control={ control }
            name="lastName"
            label={ t('fields.lastName') }
            required
        />
    );
}
